import DropdownsState from "../../models/DropdownsState";

export function getSelectedChildInitialised(state: DropdownsState) {
  return state.childUserIdInitialised;
}

export function getChildUserId(state: DropdownsState) {
  return state.childUserId;
}

export function getStartTime(state: DropdownsState) {
  return state.startTime;
}

export function getEndTime(state: DropdownsState) {
  return state.endTime;
}

export function isCustomPeriod(state: DropdownsState): boolean {
  return state.isCustomPeriod;
}
